import React from 'react';
import { common } from '../../../translates';
import Styles from './styles';
import { IConfigGeneral } from '../../../types/config';

type ListItem = {
  title: string;
  children: ListItem[];
  id: string;
};

function NestedList({ items }: { items: ListItem[] }) {
  return (
    <ul>
      {items.map((item) => (
        <li key={item.id}>
          <a href={`#${item.id}`}>{item.title}</a>
          {item.children.length > 0 && <NestedList items={item.children} />}
        </li>
      ))}
    </ul>
  );
}

function TableOfContents({
  config,
  data,
  language,
}: {
  config: IConfigGeneral;
  data: string | undefined;
  language: string;
}) {
  if (data) {
    const items: ListItem[] = JSON.parse(data);

    return items ? (
      <Styles config={config}>
        <span className="tableOfContentsHeader">{common[language].tableOfContentsTitle}</span>
        <NestedList items={items} />
      </Styles>
    ) : null;
  }

  return null;
}

export default TableOfContents;
